export class Form {
    constructor(id, name, description, partner, status, disabled, production, _sections, _answer) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.partner = partner;
        this.status = status;
        this.disabled = disabled;
        this.production = production;
        this._sections = _sections;
        this._answer = _answer;
    }
    get sections() {
        return [...this._sections];
    }
    get answers() {
        return [...this._answer];
    }
    /**
     * Retorna todas las preguntas del formulario en un array plano
     */
    getAllQuestions() {
        return this.extractQuestions(this._sections);
    }
    extractQuestions(sections) {
        const questions = sections.map(({ questions }) => questions).flat();
        questions.push(...questions.map(({ sections }) => this.extractQuestions(sections)).flat());
        return questions;
    }
}
